// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { MessageParticipantNameResponse } from './message-participant-name-response';

/** See com.rev360.pms.api.controller.messaging.ReplyAllDataResponse */
/* istanbul ignore next */
@GandalfModel
export class ReplyAllDataResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: String })
	messageContent!: string | null;

	@GandalfProperty({ designType: Number })
	messageId!: number;

	@GandalfArray(MessageParticipantNameResponse)
	nonReplyingAllMessageParticipants!: MessageParticipantNameResponse[];

	@GandalfProperty({ designType: MessageParticipantNameResponse })
	originalMessageSender!: MessageParticipantNameResponse;

	@GandalfProperty({ designType: Number })
	parentMessageId!: number | null;

	@GandalfProperty({ designType: Number })
	replyingAllMessageParticipantId!: number;

	@GandalfProperty({ designType: Number })
	rootMessageId!: number | null;

	@GandalfProperty({ designType: String })
	subject!: string;

}
